import { render, staticRenderFns } from "./bmbltj.vue?vue&type=template&id=38eeee72&scoped=true&"
import script from "./bmbltj.vue?vue&type=script&lang=js&"
export * from "./bmbltj.vue?vue&type=script&lang=js&"
import style0 from "./bmbltj.vue?vue&type=style&index=0&id=38eeee72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eeee72",
  null
  
)

export default component.exports